import RouteModel from "../../../model-factory/basic/route/RouteModel";
import {FactoryID, RouteKey} from "../../../model-factory/type-interface/ModelFactoryType";
import RouteFactory from "../../../model-factory/basic/route/RouteFactory";
import {MessageDataChoice, MessageDataModel} from "../../../data/subject/message/MessageDataFactory";
import {getModelFactory} from "../../../model-factory/ModelFactory";
import {IRouteIDs} from "../../../model-factory/type-interface/ModelFactoryInterface";
import RouteChoice from "../../../model-factory/basic/route/RouteChoice";
import DataChoice from "../../../model-factory/basic/data/DataChoice";

export class MessageListRouteModel extends RouteModel
{
    navigationRouteKey:RouteKey = "message_list_route_id";
    allowUnknownChoice:boolean = true;
    sourceDataModel:MessageDataModel | null = null;
    doCreateChoicesFromSource:boolean = true;


    applySourceToChoice(choice: RouteChoice, sourceChoice: MessageDataChoice)
    {
        super.applySourceToChoice(choice, sourceChoice);
        if(sourceChoice.isUnread){
            choice.className = "unread-message";
        }
    }

    requireSourceDataModel(): MessageDataModel | null
    {
        return getModelFactory().messageData.getSharedDataModel() as MessageDataModel;
    }
}

export default class MessageListRouteFactory extends RouteFactory
{

    id: FactoryID = "message_list_route";

    constructor()
    {
        super();


        this.choices = {

        }
    }

    birth(id: FactoryID): MessageListRouteModel
    {
        return new MessageListRouteModel(id);
    }

    getDefaultModel(): MessageListRouteModel
    {
        return this.getDefaultModelWithRoute()! as MessageListRouteModel;
    }

    defaultRouteIDs(): IRouteIDs
    {
        return {
            account_route_id : "message",
            browse_route_id : "account",
            message_route_id : "list"
        };
    }
}